import * as v from 'valibot';

import { CompetitionWinnerSchema } from '@/lib/api/requests.ts';
import { numeric, nullishAsOptional } from '@/lib/schema-utils.ts';

const AdventWinnerSchema = v.object({
  ...CompetitionWinnerSchema.entries,
  meta: v.object({
    day: numeric(),
    /** Total amount for the day, shared by every winner of that day. */
    amount: nullishAsOptional(v.string()),
    /** Amount paid down for this winner. */
    paidAmount: nullishAsOptional(v.string()),
    /** Amount moved to the Christmas Eve draw, shared by every winner of that day. */
    remainingAmount: nullishAsOptional(v.string()),
    /** Instagram post with the winner announcement, shared by every winner of that day. */
    instagramPostUrl: nullishAsOptional(v.string()),
  }),
});

export type AdventWinner = v.InferOutput<typeof AdventWinnerSchema>;

export const AdventWinnersSchema = v.array(AdventWinnerSchema);

export const AdventSummarySchema = v.object({
  totalGivenMoney: nullishAsOptional(v.string()),
  totalCutExpenses: nullishAsOptional(v.string()),
});
